"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingChecklistUnassignedHMDT = exports.TrackingChecklistUnassignedHMD = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const tracker_id_js_1 = require("../../solarxr-protocol/datatypes/tracker-id.js");
class TrackingChecklistUnassignedHMD {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTrackingChecklistUnassignedHMD(bb, obj) {
        return (obj || new TrackingChecklistUnassignedHMD()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTrackingChecklistUnassignedHMD(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TrackingChecklistUnassignedHMD()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    trackerId(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new tracker_id_js_1.TrackerId()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startTrackingChecklistUnassignedHMD(builder) {
        builder.startObject(1);
    }
    static addTrackerId(builder, trackerIdOffset) {
        builder.addFieldOffset(0, trackerIdOffset, 0);
    }
    static endTrackingChecklistUnassignedHMD(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTrackingChecklistUnassignedHMD(builder, trackerIdOffset) {
        TrackingChecklistUnassignedHMD.startTrackingChecklistUnassignedHMD(builder);
        TrackingChecklistUnassignedHMD.addTrackerId(builder, trackerIdOffset);
        return TrackingChecklistUnassignedHMD.endTrackingChecklistUnassignedHMD(builder);
    }
    unpack() {
        return new TrackingChecklistUnassignedHMDT((this.trackerId() !== null ? this.trackerId().unpack() : null));
    }
    unpackTo(_o) {
        _o.trackerId = (this.trackerId() !== null ? this.trackerId().unpack() : null);
    }
}
exports.TrackingChecklistUnassignedHMD = TrackingChecklistUnassignedHMD;
class TrackingChecklistUnassignedHMDT {
    constructor(trackerId = null) {
        this.trackerId = trackerId;
    }
    pack(builder) {
        const trackerId = (this.trackerId !== null ? this.trackerId.pack(builder) : 0);
        return TrackingChecklistUnassignedHMD.createTrackingChecklistUnassignedHMD(builder, trackerId);
    }
}
exports.TrackingChecklistUnassignedHMDT = TrackingChecklistUnassignedHMDT;
